export default {
  title: 'لیست مدیران',
  search:'جستجو ...',
  id: 'شناسه',
  name : 'نام',
  lastLogin: 'آخرین لاگین',
  CreatedAt: 'زمان ایجاد',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  success:'موفق',
  deleteConfirm:'آیا از حذف این کاربر مطمئن هستید؟'




}
